import type { ColorThemeOption, ColorTheme } from './types';

export const COLOR_THEMES: Record<ColorTheme, ColorThemeOption> = {
  zinc: {
    id: 'zinc',
    name: 'Zinc Monochrome',
    swatchHex: '#18181b',
    accentBg: 'bg-zinc-900 dark:bg-zinc-100',
    accentText: 'text-zinc-900 dark:text-zinc-100',
    accentBorder: 'border-zinc-900 dark:border-zinc-100',
    primaryBtnBg: 'bg-zinc-900 hover:bg-zinc-800 text-white dark:bg-zinc-100 dark:hover:bg-zinc-200 dark:text-zinc-900',
    primaryBtnText: 'text-white dark:text-zinc-900',
    primaryBtnHover: 'hover:bg-zinc-800 dark:hover:bg-zinc-200',
    activeNavBg: 'bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900',
    activeNavText: 'text-white dark:text-zinc-900',
    badgeBg: 'bg-zinc-100 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100',
    badgeText: 'text-zinc-900 dark:text-zinc-100',
    badgeBorder: 'border-zinc-300 dark:border-zinc-700',
    timerHeaderBg: 'bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900',
    timerHeaderText: 'text-zinc-100 dark:text-zinc-900',
  },
  indigo: {
    id: 'indigo',
    name: 'Indigo Tech',
    swatchHex: '#4f46e5',
    accentBg: 'bg-indigo-600 dark:bg-indigo-500',
    accentText: 'text-indigo-600 dark:text-indigo-400',
    accentBorder: 'border-indigo-600 dark:border-indigo-500',
    primaryBtnBg: 'bg-indigo-600 hover:bg-indigo-700 text-white dark:bg-indigo-500 dark:hover:bg-indigo-600 dark:text-white',
    primaryBtnText: 'text-white',
    primaryBtnHover: 'hover:bg-indigo-700 dark:hover:bg-indigo-600',
    activeNavBg: 'bg-indigo-600 text-white dark:bg-indigo-500 dark:text-white',
    activeNavText: 'text-white',
    badgeBg: 'bg-indigo-50 text-indigo-700 dark:bg-indigo-950/80 dark:text-indigo-300',
    badgeText: 'text-indigo-700 dark:text-indigo-300',
    badgeBorder: 'border-indigo-200 dark:border-indigo-800',
    timerHeaderBg: 'bg-indigo-600 text-white dark:bg-indigo-600 dark:text-white',
    timerHeaderText: 'text-white',
  },
  emerald: {
    id: 'emerald',
    name: 'Emerald Cyber',
    swatchHex: '#059669',
    accentBg: 'bg-emerald-600 dark:bg-emerald-500',
    accentText: 'text-emerald-600 dark:text-emerald-400',
    accentBorder: 'border-emerald-600 dark:border-emerald-500',
    primaryBtnBg: 'bg-emerald-600 hover:bg-emerald-700 text-white dark:bg-emerald-500 dark:hover:bg-emerald-600 dark:text-white',
    primaryBtnText: 'text-white',
    primaryBtnHover: 'hover:bg-emerald-700 dark:hover:bg-emerald-600',
    activeNavBg: 'bg-emerald-600 text-white dark:bg-emerald-500 dark:text-white',
    activeNavText: 'text-white',
    badgeBg: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/80 dark:text-emerald-300',
    badgeText: 'text-emerald-700 dark:text-emerald-300',
    badgeBorder: 'border-emerald-200 dark:border-emerald-800',
    timerHeaderBg: 'bg-emerald-600 text-white dark:bg-emerald-600 dark:text-white',
    timerHeaderText: 'text-white',
  },
  amber: {
    id: 'amber',
    name: 'Amber Glow',
    swatchHex: '#d97706',
    accentBg: 'bg-amber-600 dark:bg-amber-500',
    accentText: 'text-amber-600 dark:text-amber-400',
    accentBorder: 'border-amber-600 dark:border-amber-500',
    primaryBtnBg: 'bg-amber-600 hover:bg-amber-700 text-white dark:bg-amber-500 dark:hover:bg-amber-600 dark:text-slate-950 font-semibold',
    primaryBtnText: 'text-white dark:text-slate-950',
    primaryBtnHover: 'hover:bg-amber-700 dark:hover:bg-amber-600',
    activeNavBg: 'bg-amber-600 text-white dark:bg-amber-500 dark:text-slate-950',
    activeNavText: 'text-white dark:text-slate-950',
    badgeBg: 'bg-amber-50 text-amber-800 dark:bg-amber-950/80 dark:text-amber-300',
    badgeText: 'text-amber-800 dark:text-amber-300',
    badgeBorder: 'border-amber-200 dark:border-amber-800',
    timerHeaderBg: 'bg-amber-600 text-white dark:bg-amber-600 dark:text-white',
    timerHeaderText: 'text-white',
  },
  rose: {
    id: 'rose',
    name: 'Rose Crimson',
    swatchHex: '#e11d48',
    accentBg: 'bg-rose-600 dark:bg-rose-500',
    accentText: 'text-rose-600 dark:text-rose-400',
    accentBorder: 'border-rose-600 dark:border-rose-500',
    primaryBtnBg: 'bg-rose-600 hover:bg-rose-700 text-white dark:bg-rose-500 dark:hover:bg-rose-600 dark:text-white',
    primaryBtnText: 'text-white',
    primaryBtnHover: 'hover:bg-rose-700 dark:hover:bg-rose-600',
    activeNavBg: 'bg-rose-600 text-white dark:bg-rose-500 dark:text-white',
    activeNavText: 'text-white',
    badgeBg: 'bg-rose-50 text-rose-700 dark:bg-rose-950/80 dark:text-rose-300',
    badgeText: 'text-rose-700 dark:text-rose-300',
    badgeBorder: 'border-rose-200 dark:border-rose-800',
    timerHeaderBg: 'bg-rose-600 text-white dark:bg-rose-600 dark:text-white',
    timerHeaderText: 'text-white',
  },
  cyan: {
    id: 'cyan',
    name: 'Electric Cyan',
    swatchHex: '#0891b2',
    accentBg: 'bg-cyan-600 dark:bg-cyan-500',
    accentText: 'text-cyan-600 dark:text-cyan-400',
    accentBorder: 'border-cyan-600 dark:border-cyan-500',
    primaryBtnBg: 'bg-cyan-600 hover:bg-cyan-700 text-white dark:bg-cyan-500 dark:hover:bg-cyan-600 dark:text-slate-950 font-semibold',
    primaryBtnText: 'text-white dark:text-slate-950',
    primaryBtnHover: 'hover:bg-cyan-700 dark:hover:bg-cyan-600',
    activeNavBg: 'bg-cyan-600 text-white dark:bg-cyan-500 dark:text-slate-950',
    activeNavText: 'text-white dark:text-slate-950',
    badgeBg: 'bg-cyan-50 text-cyan-800 dark:bg-cyan-950/80 dark:text-cyan-300',
    badgeText: 'text-cyan-800 dark:text-cyan-300',
    badgeBorder: 'border-cyan-200 dark:border-cyan-800',
    timerHeaderBg: 'bg-cyan-600 text-white dark:bg-cyan-600 dark:text-white',
    timerHeaderText: 'text-white',
  },
};

export const DEFAULT_THEME = COLOR_THEMES.zinc;
